import {CanDeactivate} from '@angular/router';
import {CreateOptimizationReportComponent} from './create-optimization-report.component';
import {Injectable} from '@angular/core';

@Injectable()
export class CreateOptimizationReportDeactivateGuard implements CanDeactivate<CreateOptimizationReportComponent> {

  canDeactivate(component): Promise<boolean> {
    return component.canDeactivate();
  }
}
